import { Button, Modal } from "antd-mobile";
import React, { useState } from "react";
import { InputGroup, Form } from "react-bootstrap";
import $ from "jquery";
import { Card } from "react-bootstrap";
import { jsonToQuery, lowerCase, momentDate, upperCase } from "../../utils";

const AbsentStudentComment = (props) => {
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);

  const handleButtonClick = () => {
    if (props.onSuccess) props.onSuccess($("#reason").val());
  };

  return (
    <>
      <Form.Control
        as="textarea"
        name="reason"
        id="reason"
        className="fw-bold"
        rows="4"
        cols={3}
        placeholder="Enter your reason"
      />
      <Button fille="outline" block size="middle" onClick={handleButtonClick}>
        <i className="me-2 fa-regular fa-clipboard"></i> Save
      </Button>
    </>
  );
};
export default AbsentStudentComment;
